/*!
 * DeLuca Vodka - Big Thirst Headless Loader
 *
 * Install this stable file once on delucavodka.com. It fetches the config with
 * a fresh query string so future product/config/engine updates stay cache-safe.
 */

(function () {
  'use strict';

  if (window.__BT_DELUCA_LOADER_LOADED) return;
  window.__BT_DELUCA_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://checkout-6.bigthirst.com/cdn/shop/files/deluca-config.js';
  var configSrc = window.__BT_DELUCA_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_DELUCA_CONFIG_VERSION_OVERRIDE || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-deluca-config', 'true');
  head.appendChild(script);
})();
